import React from 'react';
import { compose, withProps } from 'recompose';
import { withScriptjs, withGoogleMap, GoogleMap, Marker, Polyline, DirectionsRenderer } from 'react-google-maps';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
	Collapse,
	Navbar,
	NavbarToggler,
	NavbarBrand,
	Nav,
	NavItem,
	NavLink,
	UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	NavbarText,
	Container,
	Row,
	Col,
	Button,
} from 'reactstrap';
import './App.css';
// https://maps.googleapis.com/maps/api/place/findplacefromtext/json?input=india&inputtype=textquery&fields=geometry&key=AIzaSyCPYoR69_A11vxt9ieU2fXpmgMrbA5yQE0
const MyMapComponent = compose(
	withProps({
		googleMapURL:
			'https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,directions&key=AIzaSyCPYoR69_A11vxt9ieU2fXpmgMrbA5yQE0',
		loadingElement: <div style={{ height: `100%` }} />,
		containerElement: <div style={{ height: `400px` }} />,
		mapElement: <div style={{ height: `100%` }} />,
	}),
	withScriptjs,
	withGoogleMap
)((props) => (
	<GoogleMap defaultZoom={props.zoom} defaultCenter={props.center} ref={props.onMapLoad}>
		{props.markers.length > 0 ? (
			<Polyline
				path={[
					{ lat: props.srcLatLng.lat, lng: props.srcLatLng.lng },
					{ lat: props.destLatLng.lat, lng: props.destLatLng.lng },
				]}
				options={{ strokeColor: '#FF0000 ' }}
			/>
		) : (
			''
		)}

		{props.srcLatLng != '' && props.destLatLng != '' ? (
			<DirectionsRenderer directions={props.directions}></DirectionsRenderer>
		) : (
			''
		)}
		{props.markers.length>0?props.markers.map((mark) => {
			return <Marker position={{ lat: mark.lat(), lng: mark.lng() }} onClick={props.onMarkerClick} />;
		}):''}
	</GoogleMap>
));

export default class Gmap extends React.PureComponent {
	state = {
		srcLatLng: '',
		destLatLng: '',
		distance: 0,
		drivingDistance: 0,
		markers: [],
		isOpen: false,
		directions: '',
		srcinput: '',
		destinput: '',
		zoom:5,
		center:{ lat: 54.7530022, lng: -4.7389855 },
		apiKey: 'AIzaSyCPYoR69_A11vxt9ieU2fXpmgMrbA5yQE0',
		map:'',
		loader:false
	};

	constructor(){
		super()
	}


	componentDidMount() {}

	handleMarkerClick = () => {};
	

	// onMapClick = (e) => {
	// 	console.log(e);
	// 	const lat = e.latLng.lat();
	// 	const lng = e.latLng.lng();
	// 	if ('lat' in this.state.srcLatLng) {
	// 		this.setState({ ...this.state, destLatLng: {lat,lng}, markers: [...this.state.markers, e.latLng] });
	// 	} else {
	// 		this.setState({ ...this.state, srcLatLng: {lat,lng},  markers: [...this.state.markers, e.latLng] });
	// 	}
	// };

	calculateDistance = async () => {
		if (this.state.srcLatLng != '' && this.state.destLatLng != '') {
			const src = new window.google.maps.LatLng(this.state.srcLatLng.lat, this.state.srcLatLng.lng);
			const dest = new window.google.maps.LatLng(this.state.destLatLng.lat, this.state.destLatLng.lng);
			const distance = await window.google.maps.geometry.spherical.computeDistanceBetween(src, dest);
			this.state.map.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.panTo({lat:this.state.srcLatLng.lat,lng:this.state.srcLatLng.lng})
			this.state.map.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.setZoom(13)
			console.log(distance)
			this.setState({ ...this.state, distance: distance,center:{lat:this.state.srcLatLng.lat,lng:this.state.srcLatLng.lng}} );
		}
	};

	reset = () => {
		this.state.map.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.setZoom(5)
		this.setState({
			srcLatLng: '',
			destLatLng: '',
			distance: 0,
			drivingDistance: 0,
			markers: [],
			isOpen: false,
			directions: '',
			srcinput: '',
			destinput: '',
			zoom:5,
			center:{ lat: 54.7530022, lng: -4.7389855 },
			map:'',
		loader:false


		});
	};

	handleMapLoad = (map) => { this.setState({...this.state,map}) }

	toggle = () =>
		this.setState({
			...this.state,
			isOpen: !this.state.isOpen,
		});

	calculateDrivingDistance = async () => {
		if (this.state.srcLatLng != '') {
			const baseurl = `https://maps.googleapis.com/maps/api/dis
		tancematrix/json?units=imperial&`;
			const origins = `${this.state.srcLatLng.lat},${this.state.srcLatLng.lng}`;
			const destinations = `${this.state.destLatLng.lat},${this.state.destLatLng.lng}`;

			const { apiKey } = this.state;
			const mode = 'driving';

			const url = `${baseurl}origins=${origins}&destinations=${destinations}&key=${apiKey}&mode=${mode}`;
			const response = await axios.get(url);
			const { data } = response;

			const directionsService = new window.google.maps.DirectionsService();
			const waypoints = this.state.markers.map((m) => ({
				location: { lat: m.lat(), lng: m.lng() },
				stopover: false,
			}));
			directionsService.route(
				{
					origin: { query: this.state.srcinput },
					destination: { query: this.state.destinput },
					travelMode: window.google.maps.TravelMode.DRIVING,
				},
				(result, status) => {
					console.log(result);
					if (status === window.google.maps.DirectionsStatus.OK) {
						this.setState({ ...this.state, directions: result });
					} else {
						console.log(result);
					}
				}
			);

			this.setState({ ...this.state, drivingDistance: data.rows[0].elements[0].distance.value });
		}
	};

	getPlaceCoordinates = (value, type) => {
		console.log(type);
		//const {apiKey} = this.state;
		//const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${value}&fields=geometry&key=${apiKey}`;
		if(value==''){
			return false;
		}
		this.setState({...this.state,loader:true})
		const geocoder = new window.google.maps.Geocoder();
		geocoder.geocode(
			{
				address: value,
			},
			(result, status) => {
				if (status === window.google.maps.DirectionsStatus.OK) {
					const {
						geometry: { location: marker },
					} = result[0];
					if (type == 'src') {
						this.setState({
							...this.state,
							srcLatLng: { lat: marker.lat(), lng: marker.lng() },
							markers: [...this.state.markers, marker],
							loader:false
						});
		

					} else {
						console.log('in dest');
						this.setState({
							...this.state,
							destLatLng: { lat: marker.lat(), lng: marker.lng() },
							markers: [...this.state.markers, marker],
							loader:false
						});
					}
				} else {
					console.log(result);
				}
			}
		);
	};

	render() {
		const showDistanceMarkers = true;
		if(this.state.loader) return (<div>Loading...</div>)

		return (
			<div>
				<Navbar className="themecolor1" expand="md">
					<NavbarBrand href="/" className="themecolor1">
						Distance Calculator
					</NavbarBrand>
					<NavbarToggler onClick={this.toggle} />
					<Collapse isOpen={this.state.isOpen} navbar>
						<Nav className="mr-auto" navbar></Nav>
						{/* <NavbarText>Simple Text</NavbarText> */}
					</Collapse>
				</Navbar>

				<Container>
					<Row>
						<Col>
							<h1>Measure distances</h1>
							<p>
								Use this page to measure the distance between two locations as the crow flies or when
								driving. Type in two addresses or click on the map to start
							</p>
							<label for="postcode1">Location 1:</label>
							<input
								type="text"
								id="postcode1"
								class="form-control"
								onBlur={(e) => this.getPlaceCoordinates(e.target.value, 'src')}
								onChange={(e) => this.setState({ ...this.state, srcinput: e.target.value })}
								value={this.state.srcinput}
							/>
							<label for="postcode2">Location 2:</label>
							<input
								type="text"
								id="postcode2"
								class="form-control"
								onBlur={(e) => this.getPlaceCoordinates(e.target.value, 'dest')}
								onKeyDown={(e)=>{if(e.keyCode == 13){console.log(e.target.value);this.getPlaceCoordinates(e.target.value, 'dest')}}}
								onChange={(e) => this.setState({ ...this.state, destinput: e.target.value })}
								value={this.state.destinput}
							/>{' '}
							<br />
						</Col>

						<Col xs={12}>
							<Button className="marginright2" onClick={this.calculateDistance}>
								Calculate Crow Miles
							</Button>
							<Button className="marginright2" onClick={this.calculateDrivingDistance}>
								Show Driving Path
							</Button>
							<Button className="marginright2" onClick={this.reset}>
								Reset
							</Button>
						</Col>
						<Col>
							{this.state.destLatLng.lat&&this.state.destLatLng.lng ? (
								<div>
									<table id="distanceResults">
										<tbody>
											<tr>
												<td>
													<span className="crowMiles"></span>
													As the crow flies:
												</td>
												<td id="crow">
													{typeof this.state.distance == 'number'
														? `${(this.state.distance / 1000).toFixed(2)}KM (${(
																this.state.distance /
																(1000*1.621371192)
														  ).toFixed(2)} Miles)`
														: ''}
												</td>
											</tr>
											<tr id="drivingRow">
												<td>
													<span className="drivingRow"></span>
													Driving:
												</td>
												<td id="drive">
													{typeof this.state.drivingDistance == 'number'
														? `${(this.state.drivingDistance / 1000).toFixed(2)}KM (${(
																this.state.drivingDistance /
																(1000*1.621371192)
														  ).toFixed(2)} Miles)`
														: ''}
												</td>
											</tr>
											<tr>
												<td>
													<img src="/green.png" alt="Start location" /> Start location:
												</td>
												<td id="startLoc">{`${this.state.srcLatLng.lat},${this.state.srcLatLng.lng}`}</td>
											</tr>
											<tr>
												<td>
													<img src="/red.png" alt="End location" /> End location:
												</td>
												<td id="endLoc">{`${this.state.destLatLng.lat},${this.state.destLatLng.lng}`}</td>
											</tr>
										</tbody>
									</table>
								</div>
							) : (
								''
							)}
						</Col>
						<Col xs={12}>
							<MyMapComponent isMarkerShown={this.state.isMarkerShown} {...this.state} onMapLoad={this.handleMapLoad} />

							<br />
							<br />
							<br />
						</Col>
					</Row>
					<Row></Row>
				</Container>
			</div>
		);
	}
}
